import { render, staticRenderFns } from "./config-custom-torrentrss.vue?vue&type=template&id=26f7d7fa&scoped=true&"
import script from "./config-custom-torrentrss.vue?vue&type=script&lang=js&"
export * from "./config-custom-torrentrss.vue?vue&type=script&lang=js&"
import style0 from "./config-custom-torrentrss.vue?vue&type=style&index=0&id=26f7d7fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f7d7fa",
  null
  
)

export default component.exports